import { PlanId, PlanType } from 'types/planUtils';

const PLAN_ID_TO_PLAN_TYPE_MAPPING: {
  [key in PlanId]: PlanType;
} = {
  basic: 'basic',
  business: 'business',
  capital_deposit_basic: 'basic',
  capital_deposit_business: 'business',
  capital_deposit_premium: 'premium',
  moral_person_basic: 'basic',
  moral_person_business: 'business',
  moral_person_premium: 'premium',
  physical_person_basic: 'basic',
  physical_person_premium: 'premium',
  plus: 'plus',
  pro: 'pro',
  shine_start_basic: 'basic',
  shine_start_premium: 'premium',
};

/**
 * Check whether the passed plan ID (as a string) is a known and valid plan ID.
 * The helper is a type guard.
 */
export const isValidPlanId = (planId: string): planId is PlanId => {
  return planId in PLAN_ID_TO_PLAN_TYPE_MAPPING;
};

/**
 * Given a plan ID such as "moral_person_basic",
 * it returns a more human-readable plan type (ex: "basic").
 */
export const getPlanType = (planId: PlanId): PlanType => {
  return PLAN_ID_TO_PLAN_TYPE_MAPPING[planId];
};
